import React from 'react';

export const RegistContext = React.createContext({
  userIdentity: '',
});
